import { useContext, useMemo } from "react"
import type { Context } from "react"
import type { DuplicateViewFlowActions } from "../helpers/duplicate-view-flow"

interface DuplicateFlowContext {
  setView: DuplicateViewFlowActions["setView"]
  setShowMetricsSelector: DuplicateViewFlowActions["setShowMetricsSelector"]
  setDuplicateFromViewName: DuplicateViewFlowActions["setDuplicateFromViewName"]
  setDuplicateFromTemplateId: DuplicateViewFlowActions["setDuplicateFromTemplateId"]
  setDuplicateFromViewMetrics: DuplicateViewFlowActions["setDuplicateFromViewMetrics"]
  setDuplicateReturnViewId: DuplicateViewFlowActions["setDuplicateReturnViewId"]
  clearDuplicateState: DuplicateViewFlowActions["clearDuplicateState"]
}

export function useDuplicateFlow(context: Context<DuplicateFlowContext>): DuplicateViewFlowActions {
  const {
    setView,
    setShowMetricsSelector,
    setDuplicateFromViewName,
    setDuplicateFromTemplateId,
    setDuplicateFromViewMetrics,
    setDuplicateReturnViewId,
    clearDuplicateState,
  } = useContext(context)

  return useMemo(() => ({
    setView,
    setShowMetricsSelector,
    setDuplicateFromViewName,
    setDuplicateFromTemplateId,
    setDuplicateFromViewMetrics,
    setDuplicateReturnViewId,
    clearDuplicateState,
  }), [
    setView,
    setShowMetricsSelector,
    setDuplicateFromViewName,
    setDuplicateFromTemplateId,
    setDuplicateFromViewMetrics,
    setDuplicateReturnViewId,
    clearDuplicateState,
  ])
}
